import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Eligibility from './components/Eligibility';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <Eligibility />,
  document.querySelector('#form-content')
);